import React, { useState } from "react";
import styled from "styled-components";
import orderBy from "lodash/orderBy";
import { FormFeedback, FormGroup as FormGroupStrap } from "reactstrap";

import { SearchSelect, Input } from "../../../input";
import { FONTS } from "../../../../constants";
import { _levels } from "../../types";
import { get } from "lodash";

export const CompanyInfoSecondCol = (props) => {
  const {
    isEditMovement,
    movementData,
    _divisions,
    _teams,
    invalidModule,
    handleInput,
  } = props;

  const division =
    _divisions.find((e) => e.value === movementData.division_id) || null;
  const team = _teams.find((e) => e.value === movementData.team_id) || null;
  const level = _levels.find((l) => l.value === movementData.level) || null;

  return (
    <FormWrapper>
      <FormGroup>
        <LabelCol>
          <Label>Division</Label>
        </LabelCol>
        <InputCol>
          <SearchSelect
            name="division_id"
            placeholder="Select Division"
            value={division}
            isDisabled={!isEditMovement}
            options={orderBy(_divisions, "label", "asc")}
            onChange={(e) => handleInput(e, "division_id")}
          />
        </InputCol>
      </FormGroup>
      <FormGroup>
        <LabelCol>
          <Label>Team</Label>
        </LabelCol>
        <InputCol>
          <SearchSelect
            name="team_id"
            placeholder="Select Team"
            value={team}
            isDisabled={!isEditMovement}
            options={orderBy(_teams, "label", "asc")}
            onChange={(e) => handleInput(e, "team_id")}
          />
        </InputCol>
      </FormGroup>
      <FormGroup>
        <LabelCol>
          <Label>Level</Label>
        </LabelCol>
        <InputCol>
          <ColWrapper>
            <SearchSelect
              name="level"
              placeholder="Select Level"
              value={level}
              isDisabled={!isEditMovement}
              options={orderBy(_levels, "label", "asc")}
              onChange={(e) => handleInput(e, "level")}
            />
            <WarningMessage>
              Changing this will be effective to all costings and pricing
            </WarningMessage>
          </ColWrapper>
        </InputCol>
      </FormGroup>
      <FormGroup>
        <LabelCol>
          <Label>Module</Label>
        </LabelCol>
        <InputCol>
          <ColWrapper>
            <FormGroupStrap>
              <Input
                name="Module"
                placeholder="Module"
                disabled={!isEditMovement}
                value={get(movementData, "module", "")}
                onChange={(e) => {
                  handleInput(e, "module");
                }}
                invalid={invalidModule}
              />
              <FormFeedback
                style={{ display: invalidModule ? "block" : "none" }}
              >
                Module allow only a-z, no capital, no space, no number, no
                special characters.
              </FormFeedback>
            </FormGroupStrap>
          </ColWrapper>
        </InputCol>
      </FormGroup>
    </FormWrapper>
  );
};

const Label = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #808080;
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  :nth-child(1) {
    padding-right: 6px;
  }

  :nth-last-child(1) {
    padding-left: 6px;
  }
`;

const FormGroup = styled.div`
  display: flex;
  margin-bottom: 16px;
`;

const LabelCol = styled.div`
  display: flex;
  flex: 1;
`;

const InputCol = styled.div`
  display: flex;
  flex: 2;

  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #808080;
`;

const ColWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const WarningMessage = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #f0c34e;
  margin-top: 4px;
`;



// WEBPACK FOOTER //
// ./src/components/new-employee/edit-pane/movement-info/second-column.js